import { render } from "./FooterStyleFour.vue?vue&type=template&id=81fe8dd8"
import script from "./FooterStyleFour.vue?vue&type=script&lang=js"
export * from "./FooterStyleFour.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__